import React, { useState } from 'react';
import Icon from '../AppIcon';

const CategoryFilter = ({ onCategoryChange }) => {
    const [selectedCategory, setSelectedCategory] = useState('all');

    const categories = [
        {
            id: 'all',
            label: 'All',
            icon: 'Grid3x3',
            count: 156
        },
        {
            id: 'photography',
            label: 'Photography',
            icon: 'Camera',
            count: 42
        },
        {
            id: 'catering',
            label: 'Catering',
            icon: 'UtensilsCrossed',
            count: 38
        },
        {
            id: 'decoration',
            label: 'Decoration',
            icon: 'Sparkles',
            count: 29
        },
        {
            id: 'music',
            label: 'Music & DJ',
            icon: 'Music',
            count: 24
        },
        {
            id: 'venue',
            label: 'Venues',
            icon: 'Building2',
            count: 18
        },
        {
            id: 'makeup',
            label: 'Makeup',
            icon: 'Palette',
            count: 15
        }
    ];

    const handleCategoryClick = (category) => {
        setSelectedCategory(category?.id);
        if (onCategoryChange) {
            onCategoryChange(category?.id);
        }
    };

    return (
        <div className="category-filter-container">
            <div className="category-filter-list">
                {categories?.map((category) => (
                    <button
                        key={category?.id}
                        onClick={() => handleCategoryClick(category)}
                        className={`category-filter-item ${selectedCategory === category?.id ? 'active' : ''}`}
                        aria-label={`Filter by ${category?.label}`}
                        aria-pressed={selectedCategory === category?.id}
                    >
                        <div className="category-filter-icon">
                            <Icon
                                name={category?.icon}
                                size={20}
                                strokeWidth={selectedCategory === category?.id ? 2.5 : 2}
                            />
                        </div>
                        <span className="category-filter-label">{category?.label}</span>
                        <span className="category-filter-count">{category?.count}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default CategoryFilter;